import {lazy} from "react";

export const ActiveSingleVoyageLazy = lazy(() => import('./ActiveSingleVoyage'))